import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4400Model } from '../kymw4400.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページ一覧登録サービス
 * @export RegistPageInfoListService
 * @class RegistPageInfoListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistPageInfoListService extends PlessJsonResponderSub<null> {
  model: KYMW4400Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistPageInfoListService
   */
  private getBody(): PlessRequest {
    const updObj = {
      OrderInfo: {
        parameter: {
          MediumType: this.model.searchedMediumType,
          OrderCode: this.model.searchedOrderCode,
          CoopCode: this.model.searchedCoopCode,
        },
      },
      RegistPages: {
        combination: this.model.registPages.map(_ => ({
          parameter: {
            PageNum: _.pageNum,
            Folio: _.folio,
            PageInfo: _.pageInfo,
            WebCatalogTitle: _.webCatalogTitle,
            PageTemplateId: _.pageTemplateId === KYMW4400Model.PAGE_TEMPLATE_AUTOSELECT ? null: _.pageTemplateId,
            ContactUser1: _.contactUser1,
            ContactUser2: _.contactUser2,
            ContactUser3: _.contactUser3,
            Feature1: _.feature1,
            Feature2: _.feature2,
            Feature3: _.feature3,
            AutoArrangePattern: _.autoArrangePattern,
            CommonPublishFlg: _.commonPublishFlg,
            PublishGoodsGroupIds: _.publishGoodsGroupIdList.join(','),
            TagIds: _.tagIdList.join(','),
          },
        })),
      },
      DeletePages: {
        combination: this.model.deletePages.map(_ => ({
          parameter: {
            PageId: _.pageId,
          },
        })),
      },
      UpdatePages: {
        combination: this.model.updatePages.map(_ => ({
          parameter: {
            PageId: _.pageId,
            PageNum: _.pageNum,
            Folio: _.folio,
            PageInfo: _.pageInfo,
            WebCatalogTitle: _.webCatalogTitle,
            PageTemplateId: _.pageTemplateId === KYMW4400Model.PAGE_TEMPLATE_AUTOSELECT ? null: _.pageTemplateId,
            ContactUser1: _.contactUser1,
            ContactUser2: _.contactUser2,
            ContactUser3: _.contactUser3,
            Feature1: _.feature1,
            Feature2: _.feature2,
            Feature3: _.feature3,
            AutoArrangePattern: _.autoArrangePattern,
            CommonPublishFlg: _.commonPublishFlg,
            PublishGoodsGroupIds: _.publishGoodsGroupIdList.join(','),
            TagIds: _.tagIdList.join(','),
          },
        })),
      },
    };
    if (updObj.RegistPages.combination.length < 1) delete updObj.RegistPages;
    if (updObj.DeletePages.combination.length < 1) delete updObj.DeletePages;
    if (updObj.UpdatePages.combination.length < 1) delete updObj.UpdatePages;
    return new PlessRequest({ update: updObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistPageInfoListService
   */
  execute(model: KYMW4400Model, f: () => void = null): void {
    this.model = model;
    if (
      this.model.registPages.length < 1 &&
      this.model.deletePages.length < 1 &&
      this.model.updatePages.length < 1
    )
      return;
    this.calbak = f;
    this.send('registPageInfoList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistPageInfoListService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
